import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getModules,
  createModule,
  updateModule,
  deleteModule,
  getCategories,
  getCoursePreview,
  removePreview,
  publishModule,
  unPublishModule,
} from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import {
  showSuccessToastMessage,
  showErrorToastMessage,
  showToastMessage,
  isSuperAdmin,
  isAdmin,
} from "../../../../utilities";
import Grid from "../Common/Grid";
import Spinner from "../../../User/Common/Spinner/Spinner";
import Search from "../Common/Search";
import { emptyCheck } from "../../../../utilities";
import AdminBreadcrumb from "../Common/Breadcrumb";
import RequiredField from "../Common/RequiredField";
import { API_BASE_URL, toolbarConfig } from "../../../../constants";
import PreviewModal from "../Common/PreviewModal";
import CKEditor from "ckeditor4-react";
import swal from "sweetalert";
import { CopyToClipboard } from "react-copy-to-clipboard";

class AdminModules extends Component {
  state = {
    mastermodules: [],
    modules: [],
    selectedModule: {},
    showModal: false,
    showPreviewModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: "",
    previewUrl: "",
    previewTitle: "",
    filePath: "",
    textToCopy: "",
  };
  componentDidMount() {
    this.getModulesFromService();
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow,
    });
  }
  getModulesFromService() {
    this.showSpinner(true);
    getModules()
      .then((response) => {
        this.setState({ modules: response.data, mastermodules: response.data });
        this.showSpinner(false);
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error);
        this.showErrorMessage(error);
      });
  }

  editModule(country) {
    this.setState({
      action: "edit",
      selectedModule: country,
      showModal: true,
      errorMessage: "",
    });
  }

  deleteModule(country) {
    this.setState({
      action: "delete",
      selectedModule: country,
      showDeleteModal: true,
    });
  }

  addModule() {
    this.setState({
      action: "add",
      selectedModule: {},
      showModal: true,
      errorMessage: "",
    });
  }
  onHideModal() {
    this.setState({
      showModal: false,
    });
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false,
    });
  }

  onHidePreviewModal() {
    removePreview(this.state.filePath);
    this.setState({
      showPreviewModal: false,
    });
  }

  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "Module");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }

  validate(data) {
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    return true;
  }

  saveModule() {
    const data = {
      Id: this.state.action === "edit" ? this.state.selectedModule.Id : 0,
      Name: this.refs["txtModule"].value,
      HTML: this.state.selectedModule.HTML,
      IsDelete: false, // this.refs["chkIsDeleted"].checked
    };
    if (this.validate(data)) {
      switch (this.state.action) {
        case "add":
          this.showSpinner(true);
          createModule(data)
            .then((response) => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getModulesFromService();
            })
            .catch((error) => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        case "edit":
          this.showSpinner(true);
          updateModule(data)
            .then((response) => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getModulesFromService();
            })
            .catch((error) => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        default:
          break;
      }
    }
  }
  confirmDeleteModule() {
    this.showSpinner(true);
    deleteModule(this.state.selectedModule.Id)
      .then((response) => {
        this.showSpinner(false);
        // console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedModule.Name);
        this.getModulesFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleModuleChange = (event) => {
    let selectedModule = this.state.selectedModule;
    selectedModule.Name = event.target.value;
    this.setState({ selectedModule: selectedModule });
  };

  goToCategories(value) {
    this.showSpinner(true);
    const moduleId = value.Id;
    // this.props.history.push(`/admin/${moduleId}/categories/`);
    getCategories(moduleId)
      .then((response) => {
        this.showSpinner(false);
        const learningCategoryId = response.data.filter((d) => d.Name === "Learning")[0].Id;
        this.props.history.push(`/admin/${moduleId}/${learningCategoryId}/learningcategories/`);
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error);
        this.showErrorMessage(error);
      });
  }

  handleSearchTermChange = (event) => {
    let filteredModules = this.state.mastermodules.filter((d) => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        modules: filteredModules,
        searchTerm: event.target.value,
      });
    else
      this.setState({
        modules: this.state.mastermodules,
        searchTerm: event.target.value,
      });
  };

  unPublishCourse = (value) => {
    this.showSpinner(true);
    unPublishModule(value.Id)
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          showToastMessage("success", "Unpublish Success", `${value.Name} unpublished successfully.`, this, "toastr1");
        }
        this.showSpinner(false);
        this.getModulesFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        this.showErrorMessage(error);
      });
  };

  goToUnPublishCourse = (value) => {
    swal({
      title: "Unpublish course?",
      text:
        "This action once taken will delete the course from the server. All links to this course will be disabled and will not work. Click OK to unpublish or click CANCEL if you are not sure.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willUnPublish) => {
      if (willUnPublish) {
        this.unPublishCourse(value);
      }
    });
  };

  copyText = (text) => {
    this.setState(
      {
        textToCopy: text,
      },
      () => this.refs["btnCopyToClipboard"].click()
    );
  };

  publishCourse = (value) => {
    this.showSpinner(true);
    publishModule(value.Id)
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          const url = this.getMainUrl() + response.data.path + "/index.html?sharepoint=1";
          const code = `<iframe width="100%" height="100%" src="${url}"></iframe>`;
          this.copyText(code);

          showToastMessage(
            "success",
            "Publish Success",
            `${value.Name} published successfully and code copied to clipboard for embedding in SharePoint.`,
            this,
            "toastr1"
          );
        }
        this.showSpinner(false);
        this.getModulesFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        this.showErrorMessage(error);
      });
  };

  goToPublishCourse = (value) => {
    console.log("value", value);

    let titleText = "Publish Course?";
    let text =
      "This will publish the course and generate an embed code for SharePoint. Click OK to publish or click CANCEL if you are not sure.";
    if (value.IsPublished) {
      titleText = "Republish course?";
      text =
        "This action once taken will overwrite your existing course with this current version. Click OK to republish or click CANCEL if you are not sure.";
    }
    swal({
      title: titleText,
      text: text,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willPublish) => {
      if (willPublish) {
        this.publishCourse(value);
      }
    });
  };

  goToPreviewCourse = (value) => {
    console.log("value", value);
    this.showSpinner(true);
    getCoursePreview(value.Id)
      .then((response) => {
        const url = this.getMainUrl() + response.data;
        this.setState({
          filePath: response.data.replace("index.html?preview=1", ""),
          showPreviewModal: true,
          previewUrl: url,
          previewTitle: `${value.Name} (Preview Mode)`,
        });
        this.showSpinner(false);
      })
      .catch((error) => {
        this.showSpinner(false);
        this.showErrorMessage(error);
      });
  };

  onEditorChange = (evt) => {
    const selectedModule = { ...this.state.selectedModule };
    selectedModule.HTML = evt.editor.getData();
    this.setState({
      selectedModule,
    });
  };

  getMainUrl = () => {
    const mainUrl = API_BASE_URL.substring(0, API_BASE_URL.length - 1);
    if (!mainUrl.includes("https")) return mainUrl.replace("http", "https");
    return mainUrl;
  };

  goToCopyLink = (value) => {
    const url = this.getMainUrl() + value.PublishPath + "/index.html?sharepoint=1";
    const code = `<iframe width="100%" height="100%" src="${url}"></iframe>`;
    this.copyText(code);
    showToastMessage(
      "success",
      "Code Copied!",
      `${value.Name} code copied to clipboard. You can embed it in SharePoint.`,
      this,
      "toastr1"
    );
  };

  onClick = ({ target: { innerHTML } }) => {
    console.log(`Clicked on "${innerHTML}"!`);
  };
  testClick = () => {
    this.refs["btnCopyToClipboard"].click();
  };

  render() {
    const { textToCopy } = this.state;

    let extraActions = null;
    let extraActionNames = null;

    if (isSuperAdmin() || isAdmin()) {
      extraActions = [
        (value) => this.goToCategories(value),
        (value) => this.goToPreviewCourse(value),
        (value) => this.goToPublishCourse(value),
        (value) => this.goToUnPublishCourse(value),
        (value) => this.goToCopyLink(value),
      ];
      extraActionNames = ["Manage Categories", "Preview", "Publish", "Unpublish", "Copy Code"];
    } else {
      extraActions = [(value) => this.goToCategories(value), (value) => this.goToPreviewCourse(value)];
      extraActionNames = ["Manage Categories", "Preview"];
    }

    return (
      <Aux>
        <CopyToClipboard style={{ display: "none" }} text={textToCopy}>
          <button ref="btnCopyToClipboard" type="button" onClick={this.onClick}>
            Copy to clipboard with onClick prop
          </button>
        </CopyToClipboard>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">Modules</h1>
        <AdminBreadcrumb data={[{ name: "Home", link: "/admin/modules/" }, { name: "Modules" }]} />
        <button className="btn btn-default add-btn" onClick={() => this.addModule()}>
          Add Module
        </button>

        <Search searchTerm={this.state.searchTerm} handleSearchTermChange={this.handleSearchTermChange.bind(this)} />
        <div className="clearfix"></div>
        {(isSuperAdmin() || isAdmin()) && (
          <div className="alert alert-warning" role="alert">
            <span
              style={{ left: -2, top: 2 }}
              className="glyphicon glyphicon-exclamation-sign"
              aria-hidden="true"
            ></span>
            Any changes you make on modules developed by other course developers will be visible to those developers as
            well.
          </div>
        )}

        <Grid
          headers={["#", "Module Name", "Developed By", "Created On", "Published On"]}
          values={this.state.modules}
          indexName="Id"
          properties={["Id", "Name", "CreatedBy", "Created", "PublishedOn", "Action"]}
          edit={(value) => this.editModule(value)}
          delete={(value) => this.deleteModule(value)}
          extraActions={extraActions}
          extraActionNames={extraActionNames}
        />

        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveModule()}
          form={this.addeditform}
          type="module"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />
              Name:
            </label>
            <input
              minLength="3"
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtModule"
              defaultValue={this.state.selectedModule.Name}
            />
          </div>

          <div className="form-group">
            <label>Course Information:</label>
            <CKEditor
              config={{
                height: "400",
                allowedContent: true,
                extraAllowedContent: "*(*)",
                toolbar: toolbarConfig,
              }}
              onChange={(e) => this.onEditorChange(e)}
              data={this.state.selectedModule.HTML}
              onBeforeLoad={(CKEDITOR) => (CKEDITOR.disableAutoInline = true)}
            />
          </div>
          {/* <div className="form-group">
            <label>Is Deleted?:</label>
            <input
              type="checkbox"
              className="chkBoxCustom"
              ref="chkIsDeleted"
              defaultChecked={this.state.selectedModule.IsDelete}
            />
          </div> */}
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedModule.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          confirm={() => this.confirmDeleteModule()}
          name={this.state.selectedModule.Name}
          type="module"
        />
        <PreviewModal
          title={this.state.previewTitle}
          url={this.state.previewUrl}
          showModal={this.state.showPreviewModal}
          onHideModal={() => this.onHidePreviewModal()}
        />
      </Aux>
    );
  }
}

export default AdminModules;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Modules/Modules.js